import { render, staticRenderFns } from "./SearchSpecificationsForm.vue?vue&type=template&id=4fc1a59d&"
import script from "./SearchSpecificationsForm.vue?vue&type=script&lang=js&"
export * from "./SearchSpecificationsForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchSpecificationsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports